import React, { useContext } from 'react';
import { Route, Redirect } from 'react-router-dom';
import { AuthContext } from '../reducers/Auth/AuthContext';
import { PlaceStoreContext } from '../reducers/Place/PlaceContext';

function PrivateRoute({ children, ...rest }) {
  const [authState] = useContext(AuthContext);
  const [placeState] = useContext(PlaceStoreContext);

  const { authenticated } = authState;
  const { orders, calls } = placeState?.place?.features || {};

  const hasLivePage = calls?.active || orders?.active;

  const routeRender = ({ location }) => {
    if (!placeState?.place?.features) {
      return (
        <div style={{ display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            display: 'flex',
            height: '100vh',
            justifyContent: 'center',
            alignItems: 'center',
          }}
        >
          <p style={{ color: '#000000', fontSize: '1.32rem' }}>LOADING...</p>
        </div>
      </div>
      )
    }

    if (!authenticated) {
      return <Redirect to={{ pathname: '/login', state: { from: location } }} />;
    }

    if (!hasLivePage && location.pathname === '/live') {
      return <Redirect to={{ pathname: '/manage', state: { from: location } }} />;
    }

    return children;
  };

  return <Route {...rest} render={routeRender} />;
}

export default PrivateRoute;
